module.exports = __webpack_public_path__ + "img/image1.090cc115.png";